module.exports = __webpack_public_path__ + "img/pc5.52742327.png";